/**
 * Pestaña 1 de la vista Líder: "Mi equipo" (doc 14/09 §2.2). Cards del
 * resumen global con los colores del doc, filtros (búsqueda, país, estado) y
 * listado del equipo a cargo.
 */
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  MANDATORY_BUSINESS_DAYS, countByStatus, cumplimientoNewClappers, newClappers, type LearningDashboardRow,
} from '@/../../shared/people-learning';
import { StatCard } from '@/components/ui/stat-card';
import { ClapperFilters } from './ClapperFilters';
import { ClapperTable } from './ClapperTable';
import { EMPTY_FILTERS, applyFilters, filterOptions, type RowFilters } from './learning-dash-utils';

export function MiEquipoTab({ rows, today, onDetail }: { rows: LearningDashboardRow[]; today: string; onDetail: (email: string) => void }) {
  const { t } = useTranslation();
  const k = 'people_learning.dash.team';
  const [filters, setFilters] = useState<RowFilters>(EMPTY_FILTERS);
  const options = useMemo(() => filterOptions(rows), [rows]);
  const filtered = useMemo(() => applyFilters(rows, filters), [rows, filters]);
  const c = countByStatus(filtered);
  const news = newClappers(filtered);
  const cumpl = cumplimientoNewClappers(filtered, today);

  return (
    <div className="space-y-4">
      <div className="grid gap-3 sm:grid-cols-3 lg:grid-cols-6">
        <StatCard label={t(`${k}.kpi_total`, 'Total clappers')} value={c.total} />
        <StatCard label={t(`${k}.kpi_new`, 'New Clappers a cargo')} value={news.length} sub={t(`${k}.kpi_new_hint`, { days: MANDATORY_BUSINESS_DAYS, defaultValue: 'Obligatorio · {{days}} días hábiles desde el ingreso' })} />
        <StatCard label={t(`${k}.kpi_progress`, 'En progreso')} value={c.enProgreso} fill="orange" />
        <StatCard label={t(`${k}.kpi_not_started`, 'Sin iniciar')} value={c.sinIniciar} fill="red" />
        <StatCard label={t(`${k}.kpi_done`, 'Completado')} value={c.completados} fill="green" />
        <StatCard label={t(`${k}.kpi_cumplimiento`, 'Cumplimiento del equipo')} value={`${cumpl.pct}%`} fill="orange" sub={t(`${k}.kpi_cumplimiento_hint`, { done: cumpl.done, total: cumpl.total, late: cumpl.late, defaultValue: '{{done}} de {{total}} New Clappers a tiempo · {{late}} tarde' })} />
      </div>
      <p className="text-xs text-muted-foreground">
        {t(`${k}.note`, { days: MANDATORY_BUSINESS_DAYS, defaultValue: 'Plazo estándar para New Clappers: {{days}} días hábiles desde el primer día activo.' })}
      </p>
      <ClapperFilters filters={filters} onChange={setFilters} options={options} show={{ area: false, leader: false }} />
      <ClapperTable rows={filtered} mode="team" today={today} onDetail={onDetail} />
    </div>
  );
}
